import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CreateEmailSubscriptionPayload,
  DeleteEmailSubscriptionPayload,
  DeleteReportSchedulePayload,
  LoadReportSchedulesPayload,
  ReportSchedulesFacade,
} from '@mode/shared/schedules/contract';
import * as ReportScheduleActions from '../+state/report-schedules/report-schedules.actions';
import * as ReportScheduleSelectors from '../+state/report-schedules/report-schedules.selectors';

@Injectable()
export class ReportSchedulesFacadeService extends ReportSchedulesFacade {
  override readonly reportSchedules$ = this.store.select(ReportScheduleSelectors.selectReportSchedules);
  override readonly loading$ = this.store.select(ReportScheduleSelectors.selectLoadingState);

  constructor(private readonly store: Store) {
    super();
  }

  public override loadReportSchedules(props: LoadReportSchedulesPayload) {
    this.store.dispatch(ReportScheduleActions.loadReportSchedules(props));
  }

  public override deleteReportSchedule(props: DeleteReportSchedulePayload) {
    this.store.dispatch(ReportScheduleActions.deleteReportSchedule(props));
  }

  public override createEmailSubscription(props: CreateEmailSubscriptionPayload) {
    this.store.dispatch(ReportScheduleActions.createEmailSubscription(props));
  }

  public override deleteEmailSubscription(props: DeleteEmailSubscriptionPayload) {
    this.store.dispatch(ReportScheduleActions.deleteEmailSubscription(props));
  }
}
